export const cardActivation = {
    noValidFromDate: true,
    alwaysShowAccountName: false,
};
